import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as BookingService from '_services/booking-service';
import * as UserService from '_services/user-service';

const initialState = {
    booking: null,
    transaction: null,
    user: null,
    status: 'idle',
    error: null
};

// get bookings for user
export const getBookings = createAsyncThunk('bookings/getUserBookings', async (options) => {
    return BookingService.getUserBookings(options);
});

// get info for user
export const getUser = createAsyncThunk('user/getUser', async (options) => {
    return UserService.getUserById(options);
});

const userbookingsSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [getBookings.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getBookings.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              booking: action.payload,
            }
        },
        [getBookings.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        },
        [getUser.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getUser.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              user: action.payload,
            }
        },
        [getUser.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        }
    }
});

export const { reset } = userbookingsSlice.actions;
export const selectUserBooking = state => state.booking.booking;
export const selectUserInfo = state => state.booking.user;
export const selectUserBookingStatus = state => state.booking.status;
export default userbookingsSlice.reducer;
